/**
 * Ou mene le pseudo d'un membre.
 *
 * Le mien mene a mon onglet Profil, celui d'un autre a sa fiche. Sans
 * cela, cliquer sur son propre nom dans le fil ouvrait l'ecran fait pour
 * regarder quelqu'un d'autre — avec ses boutons « Ajouter en ami » et
 * « Envoyer un message » pointes sur soi-meme.
 *
 * La regle vit ici plutot que dans chaque ecran : mon pseudo apparait
 * dans le fil, sous un commentaire, dans une mention et parmi les
 * participants d'un evenement, et l'oublier une fois suffit a laisser le
 * defaut revenir.
 */
export function profilePath(userId: string, meId: string | undefined): string {
  return userId === meId ? '/app/profile' : `/app/members/${userId}`;
}

/**
 * Les commentaires d'un post, descendus jusqu'a l'un d'eux s'il est donne.
 *
 * La cloche et la notification d'une reponse menaient en haut du fil :
 * on cherchait ensuite la reponse annoncee. Le commentaire voyage dans
 * l'adresse (`?c=`), que l'ecran lit une fois arrive.
 */
export function commentairesPath(postId: string, commentId?: string | null): string {
  return `/app/feed/${postId}/comments${commentId ? `?c=${encodeURIComponent(commentId)}` : ''}`;
}
